import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http'
import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer } from '@angular/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideRouter } from '@angular/router'
import Bugsnag from '@bugsnag/js'
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular'

import { environment } from '../environments/environment'
import {
  AuthService,
  EventService,
  KeycloakService,
  provideAbacus,
  provideLocale
} from './abacus'
import { keycloakInitializerFactory } from './abacus/factories/keycloak-initializer.factory'
import { jwtInterceptor } from './abacus/interceptors/jwt.interceptor'
import { routes } from './app.routes'

// Initialize Bugsnag if enabled
if (environment.enableBugsnag) {
  Bugsnag.start({
    apiKey: environment.bugsnagApiKey,
    releaseStage: environment.envName
  })
}

/**
 * Factory function for Bugsnag error handler
 * Returns the Bugsnag error handler for Angular
 */
function errorHandlerFactory() {
  return new BugsnagErrorHandler()
}

/**
 * Application configuration for standalone Angular 19+ app
 * Provides all necessary services, routing, and interceptors
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    
    provideLocale('en-US'),
    
    EventService,
    AuthService,
    KeycloakService,
    
    provideHttpClient(
      withInterceptors([jwtInterceptor]),
      withInterceptorsFromDi()
    ),
    
    {
      provide: ErrorHandler,
      useFactory: errorHandlerFactory
    },
    
    provideAppInitializer(() => {
      const keycloakService = inject(KeycloakService)
      const initializerFn = keycloakInitializerFactory(keycloakService)
      return initializerFn()
    }),
    
    provideAbacus()
  ]
}
